// src/components/Contact.jsx
import React from "react";
import AvailabilityCalendar from "./AvailabilityCalendar"; // Importujemy kalendarz
import "./Contact.css";

function Contact() {
  return (
    <section id="contact" className="section section-bg">
      <div className="container">
        <div className="section-title">
          <h2>Dostępność i Kontakt</h2>
        </div>
        <p className="contact-intro">
          Poniżej znajdziesz moją dostępność na najbliższe dwa tygodnie.
          <br />
          Jeśli znajdziesz pasujący termin, napisz do mnie maila z propozycją!
        </p>

        <AvailabilityCalendar />

        <div className="contact-wrapper">
          <div className="contact-info">
            <p>
              <strong>Email:</strong> anna.kowalska.matma@email.com
            </p>
            <p>
              <strong>Telefon:</strong> +48 606 856 445
            </p>
          </div>
          <a href="mailto:anna.kowalska.matma@email.com" className="cta-button">
            Napisz maila z wybranym terminem
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;